import React from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  Container,
  LoadingBounce,
  Panel,
} from '@michelin/acid-components';
import { ChangeLogEntities } from 'Types';
import useCommercialLocation from 'hooks/useCommercialLocation';
import useCustomer from 'hooks/useCustomer';
import { PlainMessage } from 'components/PlainMessage';
import useUtils from 'hooks/useUtils';
import { TABBED_CONTENT_HEIGHT } from 'Utils';
import LastModified from 'components/ChangeLog/LastModified';
import { useCommercialOverrides } from 'hooks/useCommercialOverrides';
import { PageTitle } from 'Utils/CanvasPageTitle';
import { CommercialOverridesPanel } from './CommercialOverridesPanel';

interface Props {
  action: 'edit' | 'view' | 'add',
}

export function CommercialOverrides(props: Props) {
  const { t } = useTranslation();
  const { stNumber } = useParams<{ stNumber: string }>();
  const commercialQuery = useCommercialLocation(stNumber);
  const customerQuery = useCustomer(stNumber);
  const commercialOverrides = useCommercialOverrides(stNumber);
  const { subTitle } = useUtils();

  if (commercialQuery.isLoading || customerQuery.isLoading || commercialOverrides.isLoading) return <LoadingBounce style={{ height: '70vh' }} />;
  if (!commercialOverrides.data?.overrides) return <PlainMessage title={t('Error loading commercial services')} messages={t('Please try again later')} />;

  return (
    <>
      <PageTitle
        title={t('Commercial Overrides')}
        subtitle={subTitle}
        rightItems={(<LastModified entity={ChangeLogEntities.services} />)}
      />
      <Container>
        <Panel style={{ minHeight: TABBED_CONTENT_HEIGHT }}>
          <CommercialOverridesPanel
            overrides={commercialOverrides.data}
            validations={commercialQuery.data?.validations}
            action={props.action}
          />
        </Panel>
      </Container>
    </>
  );
}
